/** Menu — document knowledge definition. Pure data. */
export default {
  id: 'menu',
  name: 'Menu',
  description: 'A structured list of items and prices for restaurants, cafes, and bars.',
  purpose: 'Item Listing & Sales',
  recommendedSizes: [
    { name: 'A4', width: 2480, height: 3508, unit: 'px' },
    { name: 'Half Letter', width: 1650, height: 2550, unit: 'px' },
  ],
  supportedOrientations: ['portrait'],
  supportsMultiplePages: true,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: true,
  supportsPricing: true,
  supportsCTA: false,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Categories', 'Items', 'Prices', 'Offers', 'QR'],
};
